import type { Auth } from "firebase/auth";
import { Firestore, collection, getDocs } from "firebase/firestore";
import { DBCollection } from "../../lib/utils/constants-shared";

import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch study guides by passage from DB (Storage first, then Firestore)
 */
export async function fetchStudyGuideByPassageFromDB(
    auth?: Auth | null,
    db?: Firestore,
    storage?: FirebaseStorage
): Promise<StudyGuideByPassage[]> {
    if (!auth || !db) return [];

    const fallback = async () => {
        try {
            const snapshot = await getDocs(collection(db, DBCollection.studyGuideByPassage));
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as StudyGuideByPassage[];
        } catch (err) {
            console.error("Error fetching study guides by passage:", err);
            return [];
        }
    };

    if (storage) {
        return await fetchCollectionFromStorage<StudyGuideByPassage>(
            storage,
            `bulk-data/${DBCollection.studyGuideByPassage}.json`,
            fallback
        );
    }

    return await fallback();
}
